import React from 'react';
import { ICoreContext } from '@msdyn365-commerce/core';
import { getCreateOrderPageUrl } from '../../../utilities/get-create-order-page-url';
import { ILxsCreateOrderResources } from '../lxs-create-order.props.autogenerated';
import { getOrderHistoryPageUrl } from '../../../utilities/get-order-history-page-url';

interface IAcknowledgementActionButtonsProps {
    context: ICoreContext;
    resources: ILxsCreateOrderResources;
}

const acknowledgementActionButtons = ({ context, resources }: IAcknowledgementActionButtonsProps) => {
    return (
        <div className='msc-form__button-group lxs-create-order__acknowledgement-action-buttons'>
            <a className='msc-cta__secondary' href={getOrderHistoryPageUrl(context.actionContext)}>
                {resources.createOrderShowOrderLabel}
            </a>
            <a className='msc-cta__primary' href={getCreateOrderPageUrl(context.actionContext)}>
                {resources.createOrderCreateNewOrderLabel}
            </a>
        </div>
    );
};

export default acknowledgementActionButtons;
